import styled, {css} from 'styled-components';
import {COLORS, MAIN_PRIMARY_1_COLOR} from '../../../shared/consts';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
    position: relative;
  box-sizing: border-box;
  background: ${COLORS.BG.ELEVATED.M};

  @media (max-width: 768px) {
    height: 100vh;
  }
`;

export const Header = styled.div`
  display: flex;
  position: relative;
  text-align: center;
  padding: 24px 16px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const CloseWrapper = styled.div`
  position: absolute;
  top: 24px;
  right: 16px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
`;

export const ImageBlock = styled.div`
  display: flex;
  justify-content: center;
`;

export const ImageWrapper = styled.div`
  max-width: 100%;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 240px;
  max-height: 240px;
`;

export const DeviceImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const Divider = styled.div`
  height: 1px;
  background: #585d6926;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
`;

export const DescriptionText = styled.p<{expanded: boolean}>`
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.FG.SOFT};
    white-space: pre-wrap;
    max-height: 300px;
    overflow: scroll;
    margin-bottom: 24px;

  ${({expanded}) =>
    !expanded &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}
`;

export const ToggleExpand = styled.button<{expanded: boolean}>`
  padding: 8px 0 0 0;
  border: none;
  background: none;
    position: absolute;
    bottom: 24px;
    left: 24px;
  cursor: pointer;
  align-self: flex-start;

  font-size: 14px;
  font-weight: 500;
  color: ${MAIN_PRIMARY_1_COLOR};

  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const ToggleIcon = styled.img<{expanded: boolean}>`
  width: 12px;
  height: 12px;

  transform: rotate(${({expanded}) => (expanded ? '180deg' : '0deg')});
`;
